export default "__VITE_ASSET__CePd_GVy__"